import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import {
  indexSubsidiariesRequest,
  importSubsidiaryRequest,
  preImportSubsidiaryRequest,
  exportSubsidiariesRequest,
  importTemplateSubsidiaryRequest,
  massiveDestroySubsidiariesRequest,
  activeSubsidiaryRequest,
  deactivateSubsidiaryRequest
} from '../../requests/subsidiaries';
import { downloadFile } from '../../services/utils';
import { sendAlert } from '../../actions/utils';
import {
  ComponentDataTable,
  DefaultModal,
  SimpleCenteredModal,
  ImportActions,
  ImportModal,
  SettingsMassiveActions
} from '../../components';

const SubsidiaryDataTableComponent = ({ columns, showSubsidiary, moreData, setMoreData, editSubsidiary }) => {
  const [simpleModalShow, setSimpleModalShow] = useState(false);
  const [amount, setAmount] = useState(0);
  const [modalAction, setModalAction] = useState(() => null);
  const [modalBody, setModalBody] = useState('');
  const [modalItem, setModalItem] = useState({});
  const [modalShow, setModalShow] = useState(false);
  const [modalTitle, setModalTitle] = useState('');
  const [onRequest, setOnRequest] = useState(true);
  const [query, setQuery] = useState({});
  const [subsidiaries, setSubsidiaries] = useState([]);
  const [clearSelectedRows, setClearSelectedRows] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedCount, setSelectedCount] = useState('');

  const handleSelectedRows = item => {
    setSelectedRows(item.selectedRows);
    setSelectedCount(item.selectedCount);
  };

  const dispatch = useDispatch();

  const handleSuccessIndex = response => {
    const { data, metadata } = response.data;
    setSubsidiaries(data);
    setAmount(metadata.amount);
    setOnRequest(false);
  };

  const handleRequest = async params => {
    setOnRequest(true);
    setQuery(params);
    indexSubsidiariesRequest({
      dispatch,
      params,
      successCallback: handleSuccessIndex
    });
  };

  const handleModalClose = () => {
    setModalShow(false);
    setSimpleModalShow(false);
    setOnRequest(false);
  };

  const handleSuccessRemove = message => {
    dispatch(sendAlert({ kind: 'success', message }));
    handleModalClose();
    setOnRequest(false);
    setMoreData(!moreData);
  };

  const handleFailureRequest = error => {
    const { response } = error;
    handleModalClose();
    setOnRequest(false);
    dispatch(sendAlert({ kind: 'error', message: response?.data?.message }));
  };

  const removeSubsidiary = item => {
    const subsidiariesSelected = item.id;
    setOnRequest(true);
    massiveDestroySubsidiariesRequest({
      params: { ids: subsidiariesSelected },
      dispatch,
      successCallback: handleSuccessRemove('Sucursal Eliminada correctamente'),
      failureCallback: handleFailureRequest,
      callback: () => {
        handleModalClose();
        setOnRequest(false);
      }
    });
  };

  const handleExportRequest = () => {
    setOnRequest(true);
    exportSubsidiariesRequest({
      dispatch,
      params: { ...query, paginate: false },
      successCallback: response => {
        downloadFile(response);
        setOnRequest(false);
        setModalShow(false);
      },
      failureCallback: handleFailureRequest
    });
  };

  const handleButtonClick = (item, action) => {
    switch (action) {
      case 'show':
        showSubsidiary(item);
        break;
      case 'edit':
        editSubsidiary(item);
        break;
      case 'destroy':
        setModalTitle('Eliminar Sucursal');
        setModalShow(true);
        setModalItem(item);
        setModalBody('¿Estás seguro que deseas eliminar este Sucursal?');
        setModalAction(() => removeSubsidiary);
        break;
      default:
        // eslint-disable-next-line no-console
        console.log('Error: Action not found');
    }
  };

  const massiveDeleteSubsidiary = () => {
    const subsidiariesSelected = selectedRows.map(item => item.id);
    setOnRequest(true);
    massiveDestroySubsidiariesRequest({
      params: { ids: subsidiariesSelected },
      dispatch,
      successCallback: handleSuccessRemove('Sucursales  Eliminados correctamente'),
      failureCallback: handleFailureRequest,
      callback: () => {
        handleModalClose();
        setOnRequest(false);
        setClearSelectedRows(!clearSelectedRows);
      }
    });
  };

  const massiveActiveSubsidiary = () => {
    const subsidiariesSelected = selectedRows.map(item => item.id);
    setOnRequest(true);
    activeSubsidiaryRequest({
      params: { ids: subsidiariesSelected },
      dispatch,
      successCallback: handleSuccessRemove('Sucursales Activados correctamente'),
      callback: () => {
        handleModalClose();
        setOnRequest(false);
        setClearSelectedRows(!clearSelectedRows);
      }
    });
  };

  const massiveDeactivateSubsidiary = () => {
    const subsidiariesSelected = selectedRows.map(item => item.id);
    setOnRequest(true);
    deactivateSubsidiaryRequest({
      params: { ids: subsidiariesSelected },
      dispatch,
      successCallback: handleSuccessRemove('Sucursales Desactivados correctamente'),
      callback: () => {
        handleModalClose();
        setOnRequest(false);
        setClearSelectedRows(!clearSelectedRows);
      }
    });
  };

  const handleImportModalExceptions = error => {
    if (error?.response?.status === 422) {
      const alertInfo = <pre>{error?.response?.data?.message}</pre>;
      setModalTitle('Información Relevante');
      setModalShow(true);
      setModalBody(alertInfo);
      setModalAction(() => handleModalClose);
    } else {
      dispatch(sendAlert({ kind: 'error', message: error?.response?.data?.message }));
    }
  };

  const handleMassAction = action => {
    switch (action) {
      case 'import':
        setSimpleModalShow(true);
        break;
      case 'export':
        setModalTitle('Exportar Sucursales');
        setModalShow(true);
        setModalBody('¿Estás seguro que deseas exportar Sucursales?');
        setModalAction(() => handleExportRequest);
        break;
      case 'massive_destroy':
        setModalTitle('Eliminar Sucursal');
        setModalShow(true);
        setModalBody('¿Estás seguro que deseas eliminar las Sucursales seleccionados?');
        setModalAction(() => massiveDeleteSubsidiary);
        break;
      case 'massive_active':
        setModalTitle('Activar Sucursales');
        setModalShow(true);
        setModalBody('¿Estás seguro que deseas activar las Sucursales seleccionados?');
        setModalAction(() => massiveActiveSubsidiary);
        break;
      case 'massive_deactivate':
        setModalTitle('Desactivar Sucursales');
        setModalShow(true);
        setModalBody('¿Estás seguro que deseas desactivar las Sucursales seleccionadas?');
        setModalAction(() => massiveDeactivateSubsidiary);
        break;
      default:
        // eslint-disable-next-line no-console
        console.log('Error: Action not found');
    }
  };

  return (
    <>
      <ComponentDataTable
        onRequest={onRequest}
        columns={columns(handleButtonClick)}
        data={subsidiaries}
        totalRows={amount}
        selectableRows
        withMassActions
        massActions={
          <>
            <ImportActions model="Subsidiary" handleClick={handleMassAction} />
            <SettingsMassiveActions model="Subsidiary" handleClick={handleMassAction} disabled={!selectedCount} />
          </>
        }
        moreData={moreData}
        resourceRequest={handleRequest}
        onRowClicked={item => handleButtonClick(item, 'show')}
        pointerOnHover
        preName="subsidiaries"
        clearSelectedRows={clearSelectedRows}
        onSelectedRowsChange={handleSelectedRows}
      />
      <DefaultModal
        title={modalTitle}
        body={modalBody}
        show={modalShow}
        handleClose={handleModalClose}
        handleConfirm={() => modalAction(modalItem)}
        titleBtnClose="Cancelar"
        titleBtnSave="Confirmar"
        disabled={onRequest}
      />

      <SimpleCenteredModal
        title="Importar Sucursales"
        body={
          <ImportModal
            onDropUploaded={preImportSubsidiaryRequest}
            handleTemplate={importTemplateSubsidiaryRequest}
            hideModal={() => setSimpleModalShow(false)}
            onHide={importSubsidiaryRequest}
            updateData={() => setMoreData(!moreData)}
            handleExceptions={handleImportModalExceptions}
          />
        }
        show={simpleModalShow}
        onHide={() => setSimpleModalShow(false)}
      />
    </>
  );
};
export default SubsidiaryDataTableComponent;
